import React from "react";
import "../sass/main.scss";
import { Button, Card, Hidden, Link, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Verification = () => {
  const navigate = useNavigate();
  function getCodeBoxElement(index) {
    return document.getElementById("codeBox" + index);
  }
  function onKeyUpEvent(index, event) {
    const eventCode = event.which || event.keyCode;
    if (parseInt(getCodeBoxElement(index).value) > 10) {
      return false;
    }
    if (getCodeBoxElement(index).value.length === 1) {
      if (index + 1 <= 6) {
        getCodeBoxElement(index + 1).focus();
      } else {
        // getCodeBoxElement(index).blur();
        // Submit code
        // console.log("submit code ");
      }
    }

    if (eventCode === 8 && index === 6) {
      document.getElementById("codeBox6").value = "";
    }

    if (eventCode === 8 && index !== 1) {
      getCodeBoxElement(index - 1).focus();
    }
  }
  function onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const currentElement = getCodeBoxElement(item);
      if (!currentElement.value) {
        currentElement.focus();
        break;
      }
    }
  }

  const handleMaxLength = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  return (
    <>
      <div className="fluid-container background">
        <div className="main">
          <Card className="card">
            <div className="column-center p-2">
              <h4>Your Security Matters</h4>
            </div>
            <div className="row">
              <div className="col-sm-12 p-2 column-center">
                <label>Confirm your email</label>
                <label>test@test.com</label>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 column-center p-2">
                <form>
                  <input
                    id="codeBox1"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(1, event)}
                    onFocus={() => onFocusEvent(1)}
                    onKeyPress={handleMaxLength}
                  />
                  <input
                    id="codeBox2"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(2, event)}
                    onFocus={() => onFocusEvent(2)}
                    onKeyPress={handleMaxLength}
                  />
                  <input
                    id="codeBox3"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(3, event)}
                    onFocus={() => onFocusEvent(3)}
                    onKeyPress={handleMaxLength}
                  />
                  <input
                    id="codeBox4"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(4, event)}
                    onFocus={() => onFocusEvent(4)}
                    onKeyPress={handleMaxLength}
                  />
                  <input
                    id="codeBox5"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(5, event)}
                    onFocus={() => onFocusEvent(5)}
                    onKeyPress={handleMaxLength}
                  />
                  <input
                    id="codeBox6"
                    type="number"
                    maxLength="0"
                    onKeyDown={(event) => onKeyUpEvent(6, event)}
                    onFocus={() => onFocusEvent(6)}
                    onKeyPress={handleMaxLength}
                  />
                </form>
              </div>
            </div>
            <div className="row">
              <div className="column-center column-center p-2">
                <label className="label">
                  Code hasn't arrived?{" "}
                  <span className="text-underline">Re-send code</span>
                  <label>&nbsp;or&nbsp;</label>
                  <span className="text-underline">contact us</span>
                </label>
              </div>
            </div>
            <div className="row margintop">
              <div className="column-center column-center p-2">
                <label className="label">
                  Check your spam folder and the spelling of your email address.
                </label>
                <label className="label">
                  Incorrect email?{" "}
                  <span
                    className="text-underline"
                    onClick={() => navigate("/")}
                  >
                    Edit email address
                  </span>
                </label>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Verification;
